import { ContainerMixin } from 'vue-slicksort';

export default {
  name: 'SectionList',
  mixins: [ContainerMixin],
  mounted() {
    this.scrollContainer = this.useWindowAsScrollContainer
      ? this.document.documentElement
      : this.container;
  },
  render(h) {
    return h('div', this.$slots.default);
  }
};
